import './simpleCard.css';

function SimpleCard(props) {
  const { bgColor, children } = props;

  return (
    <div className="card" style={{ backgroundColor: bgColor }}>
      {children}
    </div>
  );
}

export default SimpleCard;
